import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";
import { es } from "./locales/es";
import { getInitialLanguage } from "@/stores/usePreferencesStore";

const addNamespacePrefixCompatibility = <T extends Record<string, unknown>>(resources: T): T => {
  const namespaceEntries = Object.entries(resources);
  const rawNamespaces = Object.fromEntries(namespaceEntries);

  return Object.fromEntries(
    namespaceEntries.map(([namespace, value]) => [
      namespace,
      typeof value === "object" && value !== null
        ? {
            ...value,
            ...rawNamespaces,
          }
        : value,
    ]),
  ) as T;
};

void i18n.use(initReactI18next).init({
  resources: {
    en: addNamespacePrefixCompatibility(en),
    es: addNamespacePrefixCompatibility(es),
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  supportedLngs: ["en", "es"],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
